(function () {
  'use strict';

  var DEFERRED = [
    'https://cdn.attn.tv/belfurniture/dtag.js',
    'https://d3hw6dc1ow8pp2.cloudfront.net/referrals/js/referrals-api.js',
    'https://api.fastbundle.co/scripts/cart.js?rgn=573199',
    'https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js',
         ];

  var FALLBACK_MS = 6000; // load anyway after this, for visitors who never interact
  var EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'];

  var fired = false;

  function loadAll() {
    if (fired) return;
    fired = true;

    EVENTS.forEach(function (e) {
      window.removeEventListener(e, loadAll, { passive: true });
    });

    DEFERRED.forEach(function (src) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      document.head.appendChild(s);
    });
  }

  if (!DEFERRED.length) return;

  EVENTS.forEach(function (e) {
    window.addEventListener(e, loadAll, { once: true, passive: true });
  });

  window.setTimeout(loadAll, FALLBACK_MS);
})();
